/* WEELZ - last-resort image error recovery.

   Recovery happens ONLY after a genuine IMG `error` event. There is no
   page-wide sweep: a native lazy image that is far off-screen legitimately
   reports complete-with-zero-naturalWidth long before it loads, and
   treating that as failure rewrote healthy images across the collection -
   which is exactly the intermittent-blank behavior this file used to
   cause. Root layout causes are fixed in CSS; images must never depend on
   this script.

   One retry maximum per image, at a modest fixed width with the
   responsive attributes removed. Healthy and off-screen images are never
   touched. */
(function () {
  'use strict';

  var RETRY_W = 480;

  function shrink(url, w) {
    if (!url || url.indexOf('data:') === 0) return null;
    var clean = url.split('&width=')[0].split('?width=')[0];
    return clean + (clean.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function isProductImage(el) {
    return !!(el.closest && el.closest(
      '.product-media, .card-gallery, .weelz-fy__grid, .resource-list, .weelz-shelf, .cart-items__media'
    ));
  }

  document.addEventListener('error', function (event) {
    var el = event.target;
    if (!el || el.tagName !== 'IMG') return;
    if (!isProductImage(el)) return;
    if (el.getAttribute('data-weelz-retried')) return;
    el.setAttribute('data-weelz-retried', '1');

    var url = shrink(el.currentSrc || el.getAttribute('src'), RETRY_W);
    if (!url) return;
    el.removeAttribute('srcset');
    el.removeAttribute('sizes');
    el.src = url;
  }, true);
})();
